<template lang="html">
 <div>
   <v-header backTo="Login profissional">
        <router-link  :to="{name: 'client-login'}" class="linkLogin">
          Entrar
        </router-link>
    </v-header>
  <v-page class="page-registerSuccess" :profile="profile" :style="{ backgroundImage: `url(${img_background_url})` }">

    <div class="autoRegister">
    <v-login class="card-register">
      <div class="center">
          <div class="registerLeft">
            <div class="company">
              <p>E</p>
              <p>M</p>
              <p>P</p>
              <p>R</p>
              <p>E</p>
              <p>S</p>
              <p>A</p>
            </div>
            <div>
              <img class="photo" :src="img_url">
            </div>
          </div>
         <div class="card-login">

          <v-logo class="" />
          <v-text tag="h2" class="title h4 center "
            >Sua conta foi criada!</v-text
          >
          <p class="text-center">
            Enviamos um email de confirmação para a sua conta de email
            informada.
          </p>

      </div>
      </div>
    </v-login>
    </div>
  </v-page>
</div>
</template>

<script>
export default {
  data() {
    return {

      img_url: require('../../assets/photoPeople/Lucas.png'),
      img_background_url: require('../../assets/background/fundoAzul.svg'),

    };
  }
}
</script>

<style lang="scss">
.linkLogin {
  color: white;
}
.page {
  min-height: calc(100vh - 60px);
}
.page-registerSuccess{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .autoRegister {
    width: 75%;
  }
  .card-register {
    max-width: 100%;
    flex-basis: auto;
    flex-grow: 1;
    border-radius: 22px;
    @include media-breakpoint-up(md) {
      width: 100%;
    }
    .center {
      display: flex;
      align-items: center;
      padding: 2rem 2rem 0 0;

      @include media-breakpoint-down(md) {
        padding: 2rem;
      }
    }
    .registerLeft {
      display: flex;
      align-items: flex-end;

      height: 100%;
      width: 60%;
      @include media-breakpoint-down(md) {
        display: none;
      }
    }

    .photo {
      display: block;
      height: 700px;
      margin-top: 6px;
    }
    .company {
      background-color: #0377aa;
      color: white;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 10px 25px;
      height: calc(100vh - 450px);
      align-items: center;
      font-weight: 700px;
      font-weight: 700;
      font-size: 20px;
      border-radius: 0 10px 0 20px;

      p {
        margin: 0;
      }
    }
  }
.card-login {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
  footer.page-footer {
    //background-color: white;
    margin-top: auto;
    color: white;
  }
  .registeHere {
    display: flex;
    color: #0377aa !important;
  }
}
</style>





// WEBPACK FOOTER //
// src/parts/pages/register-success.vue